import { useSession } from "~/app/providers/SessionProvider";
import type { PageMetadata } from "~/app/api/pageData";
import { FCCBanner, isFCCBannerVisible } from "~/features/freeCapacityPush/components/FCCBanner/FCCBanner";
import { TopBannersSection } from "~/features/navigation/components/TopBannersSection/TopBannersSection";
import type { SchaefflerTopBannerData } from "~/features/cms/components/schaefflerTopBanner/SchaefflerTopBannerComponent";

export function StorefrontCampaignBanners({ metadata }: { metadata: PageMetadata }) {
  const session = useSession();
  const cmsBanners = metadata.slots
    .filter((slot) => slot.position === "TopHeaderSlot")
    .flatMap((slot) => slot.components)
    .filter((component) => component.typeCode === "SchaefflerTopBannerComponent" && component.props)
    .map((component) => component.props as unknown as SchaefflerTopBannerData);

  return (
    <>
      {isFCCBannerVisible(session?.commerceContext?.fccShowBannerEnabled) && <FCCBanner />}
      <TopBannersSection cmsBanners={cmsBanners} />
    </>
  );
}
